import { render, staticRenderFns } from "./MasterPR.vue?vue&type=template&id=ca5678cc"
import script from "./MasterPR.vue?vue&type=script&lang=js"
export * from "./MasterPR.vue?vue&type=script&lang=js"
import style0 from "./MasterPR.vue?vue&type=style&index=0&id=ca5678cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports